import { MAKEUP_STATUS_FILTER_ALL } from "@/features/makeups/shared/makeupStatusFilters";
import type { MakeupRequestFiltersState } from "@/features/makeups/shared/makeupRequestFilters";
import { MakeupStatus } from "@/openapi/generated";

export type MakeupQueueView = "review" | "scheduled";

export const MAKEUP_QUEUE_VIEW_REVIEW: MakeupQueueView = "review";
export const MAKEUP_QUEUE_VIEW_SCHEDULED: MakeupQueueView = "scheduled";

export const MAKEUP_QUEUE_REVIEW_REFETCH_MS = 30_000;

export function parseMakeupQueueView(
  searchParams: URLSearchParams,
): MakeupQueueView {
  const raw = searchParams.get("view")?.trim().toLowerCase();
  if (raw === "scheduled" || raw === "lookup") {
    return MAKEUP_QUEUE_VIEW_SCHEDULED;
  }
  if (raw === "review" || raw === "to-review") {
    return MAKEUP_QUEUE_VIEW_REVIEW;
  }
  const status = searchParams.get("status");
  if (status === MakeupStatus.Pending) {
    return MAKEUP_QUEUE_VIEW_REVIEW;
  }
  return MAKEUP_QUEUE_VIEW_REVIEW;
}

export function makeupQueueViewLabel(view: MakeupQueueView): string {
  return view === MAKEUP_QUEUE_VIEW_REVIEW ? "To review" : "Scheduled";
}

export function makeupQueueViewDescription(view: MakeupQueueView): string {
  if (view === MAKEUP_QUEUE_VIEW_REVIEW) {
    return "Pending requests that need approve, propose, or decline.";
  }
  return "Approved makeups — search by student, class, date, or location.";
}

export function resolveMakeupQueueFilters(
  view: MakeupQueueView,
  filters: MakeupRequestFiltersState,
): MakeupRequestFiltersState {
  if (view === MAKEUP_QUEUE_VIEW_REVIEW) {
    return { ...filters, status: MakeupStatus.Pending };
  }
  if (
    filters.status === MAKEUP_STATUS_FILTER_ALL ||
    filters.status === MakeupStatus.Pending
  ) {
    return { ...filters, status: MakeupStatus.Approved };
  }
  return filters;
}

/** UI filter state — view-specific status is applied only in {@link resolveMakeupQueueFilters}. */
export function defaultFiltersForMakeupQueueView(
  view: MakeupQueueView,
  current: MakeupRequestFiltersState,
): MakeupRequestFiltersState {
  const next = { ...current };
  if (view === MAKEUP_QUEUE_VIEW_REVIEW) {
    return { ...next, status: MAKEUP_STATUS_FILTER_ALL };
  }
  if (next.status === MakeupStatus.Pending) {
    return { ...next, status: MAKEUP_STATUS_FILTER_ALL };
  }
  return next;
}
